module.exports = __webpack_public_path__ + "static/together_event02_icon02-d8cd83ed06589329f3b8efaa365f241f.png";